(function () {
  'use strict';

  const { layout } = window.Universe;

  class Lookbook {
    constructor(containerEl) {
      this.containerEl = containerEl || null;
      this.init();
    }

    setup() {
      if (this.DOM.items.length) {
        this.handleClick = (event) => {
          event.preventDefault();
          const index = this.DOM.items.indexOf(event.currentTarget);
          this.select(index);
        };

        this.DOM.items.forEach((item) => {
          item.addEventListener('click', this.handleClick);
        });

        if (Shopify.designMode) {
          const section = this.DOM.container.closest('.shopify-section');
          section.addEventListener('shopify:section:select', this.animate.bind(this));
          section.addEventListener('shopify:section:deselect', this.closeAll.bind(this));
          this.DOM.container.addEventListener('shopify:block:select', (event) => {
            this.open(this.DOM.items.indexOf(event.target));
          });
        }
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    resize() {}

    destroy() {
      if (this.DOM) {
        this.DOM.items.forEach((item) => {
          item.removeEventListener('click', this.handleClick);
        });
        this.DOM = undefined;
      }
    }

    init() {
      const lookbookContainer = this.containerEl || document.querySelector('.js-lookbook');
      const items = lookbookContainer ? lookbookContainer.querySelectorAll('.hotspot') : null;

      if (lookbookContainer && items && items.length) {
        this.DOM = {
          container: lookbookContainer,
          items: Array.from(items),
        };

        this.isMobile = layout.window.width < 768;
        this.wasMobile = this.isMobile;

        this.setup();
      }
    }

    animate() {
      this.openAll();
      setTimeout(() => { this.closeAll(); }, 3e3);
    }

    open(selectedIndex) {
      this.DOM.items.forEach((item, index) => {
        item.classList.toggle('active', selectedIndex === index);
      });
    }

    openAll() {
      this.DOM.items.forEach((item) => {
        item.classList.add('active');
      });
    }

    closeAll() {
      this.DOM.items.forEach((item) => {
        item.classList.remove('active');
      });
    }

    select(selectedIndex) {
      this.DOM.items.forEach((item, index) => {
        item.setAttribute('aria-pressed', selectedIndex === index ? 'true' : 'false');
      });
      this.DOM.container.dispatchEvent(
        new CustomEvent('lookbook:change', {
          bubbles: true,
          detail: { index: selectedIndex },
        })
      );
    }
  }

  window.Universe.Lookbook = Lookbook;
})();
